import { Button } from '@mui/material';
import type { Control } from 'react-hook-form';
import { useConnectToPaddle } from '../../hooks/connect-to-paddle';
import type { PaddleRegisterFormValues } from '../PaddleRegisterFormSchema';

interface Props {
  control: Control<PaddleRegisterFormValues>;
}

export const PaddleRegistrationFooter = ({ control }: Props) => {
  const connectToPaddle = useConnectToPaddle(control);

  const { handleSubmit } = control;
  const submitHandler = handleSubmit((formValues) => connectToPaddle(formValues.apiToken, formValues.environment));

  return (
    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
      <Button variant="contained" onClick={submitHandler}>
        Connect to Paddle
      </Button>
    </div>
  );
};
